
<template>
  <div class="container-single-7button">
    <button
      v-for="btn in options"
      :key="btn.value"
      class="btn7button-single"
      :class="`op-${btn.value}${questionId} is-${questionId}`"
      :style="{'background': isGradient ? btn.bgColor : bgColor, 'color': textColor }"
      @click="selectOption(btn, `.op-${btn.value}${questionId}`)"
      >{{ $t(btn.label) }}</button>
  </div>
</template>

<script>
import { gradientMaker } from '../../_helpers/gradientColors'

export default {
  name: 'Single7button',
  status: 'prototype',
  release: '1.0.0',
  props: {
    questionType: {
      type: String
    },
    questionUi: {
      type: String
    },
    questionId: {
      type: String
    },
    textColor: {
      type: String,
      default: '#242424'
    },
    isGradient: {
      type: Boolean,
      default: true
    },
    bgColor: {
      type: String
    },
    rating: {
      type: String
    }
  },
  data () {
    return {
      options: []
    }
  },
  mounted () {
    this.options = [
      { label: 'ces.totally_disagree', value: 0 },
      { label: 'ces.disagree', value: 15 },
      { label: 'ces.partially_disagree', value: 30 },
      { label: 'ces.neutral', value: 50 },
      { label: 'ces.partially_agree', value: 65 },
      { label: 'ces.agree', value: 80 },
      { label: 'ces.totally_agree', value: 100 }
    ]

    if (this.isGradient) {
      gradientMaker.checkGradientAndReturnTheColors(this.questionType, this.questionUi, this.options)
    }

    const responseOnLoad = this.options.find(e => e.value.toString() === this.rating)

    if (responseOnLoad) {
      setTimeout(() => {
        this.selectOption(responseOnLoad, `.op-${responseOnLoad.value}${this.questionId}`)
      }, 10)
    }
  },
  methods: {
    selectOption (e, btnClass) {
      const valueToSend = { rating: e.value, value: this.$t(e.label) }
      const buttons = document.querySelectorAll(`.is-${this.questionId}`)

      for (const child of buttons) {
        child.style.borderColor = 'transparent'
        child.style.transform = 'scale(1)'
      }

      const selectedButton = document.querySelector(btnClass)

      selectedButton.style.borderColor = '#000000'
      selectedButton.style.transform = 'scale(1.1)'

      return this.$emit('isValue', valueToSend)
    }
  }
}
</script>

<style lang="scss" scoped>
:root { font-size: 62.5%; }

.container-single-7button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .btn7button-single {
    width: 10rem;
    height: 8rem;
    margin: 0 1rem;
    border-radius: 0.5rem;
    border: none;
    cursor: pointer;
    font-size: 1.4rem;
    border: 0.2rem solid transparent;
    font-family: "Open Sans", Helvetica, Arial, sans-serif;
  }
  .btn7button-single:hover {
    transform: scale(1.020);
  }
}

@media only screen and (max-width: 500px) {
  .container-single-7button {
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    .btn7button-single {
      width: 7rem;
      height: 5.5rem;
      margin: 0 0.3rem;
      margin-bottom: 10px;
      font-size: 1rem;
    }
  }
}
</style>
